import React from "react";
import { styled } from "@mui/system";

type Props = {
  vertical?: number;
  horizontal?: number;
};

const View = styled("div", {
  shouldForwardProp: (props) => props !== "vertical" && props !== "horizontal",
})<Pick<Props, "vertical" | "horizontal">>`
  height: ${({ vertical }) => (vertical || 1) * 16}px;
  width: ${({ horizontal }) => (horizontal || 0) * 16}px;
`;

export const Spacer = (props: Props) => {
  return <View {...props} />;
};
